import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';

import LayoutSmall from '../../../layouts/LayoutSmall';
import { Store } from '../../../model/store/Store';
import { INDEX } from '../../../routes';

import cls from '../Domain.module.scss';

export const Success = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const store = useInstance(Store);

    return (
        <LayoutSmall title={t('Activated successfully')} green={true}>
            <div className={cls.page}>
                <div>
                    {t('Workspace')}
                    <br />
                    <span className={'bold'}>{store.domain.currentDomain().name}</span>
                </div>
                <div>
                    {t('Active till')}
                    <br />
                    <span className={'bold'}>
                        {dayjs(store.domain.currentDomain().activeTill).format('DD MMMM YYYY')}
                    </span>
                </div>
                <div>
                    {t('Users')}
                    <br />
                    <span className={'bold'}>{store.domain.currentDomain().activeUsers}</span>
                </div>
                <div>
                    <Button onClick={() => navigate(INDEX)}>{t('Continue working')}</Button>
                </div>
            </div>
        </LayoutSmall>
    );
});
